import { RadioGroupV2, RadioV2 } from "@boi/react-components";
import { FormContext, iChoice, iControlProps } from "../types";
import React, { useEffect, useState } from "react";
import { evaluates_as_hiddenV2 } from "../conditional-logic";
import { ID, replaceMergeTagsInString, stringHasValueTag } from "../helper";

export type RadioProps = iControlProps & {
    context?: FormContext;
    choices: iChoice[];
    id?: string | number;
};

const RadioTraditional = (props: RadioProps) => {
    const [selected, setSelected] = useState(
        props.context?.getValue(`${props.name}`) || ""
    );

    const rid = ID();
    const refs: React.RefObject<HTMLInputElement>[] = [];

    const choices = (props.choices || []).reduce(
        (
            options: {
                labelProps: { label: string };
                value: string;
                id: string;
            }[],
            choice: iChoice,
            idx: number
        ) => {
            let hidden = false;
            if (props.context && choice.conditionalLogic) {
                hidden = evaluates_as_hiddenV2(
                    choice.conditionalLogic,
                    props.context.state
                );
            }
            if (!hidden) {
                let tempLabel = choice.text;
                if (!stringHasValueTag(choice.value)) {
                    tempLabel = replaceMergeTagsInString(
                        choice.text,
                        props.context ? props.context.getValues() : {}
                    );
                }

                return [
                    ...options,
                    {
                        labelProps: { label: tempLabel },
                        value: choice.value,
                        id: `radio[${rid}][${idx}]`,
                        checked: choice.value === selected
                    }
                ];
            } else {
                if (choice.value === props.context?.getValue(`${props.name}`)) {
                    props.context?.unsetValue(`${props.name}`);
                }
                return options;
            }
        },
        []
    );

    // the refs and the initializedRef are used to set the tabindex attribute
    // on the radio inputs after the component has mounted
    // this is to ensure that the radio inputs are focusable
    (choices || []).forEach(() => {
        refs.push(React.createRef<HTMLInputElement>());
    });

    const initializedRef: Array<number> = [];

    useEffect(() => {
        refs.forEach((ref, idx) => {
            if (!initializedRef.includes(idx)) {
                ref.current?.setAttribute("tabindex", "0");
                initializedRef.push(idx);
            }
        });
    }, []);

    return (
        <RadioGroupV2
            aria-label="RadioGroup label"
            name={props.name || `radio[${rid}]`}
            defaultValue={selected}
            onChange={value => {
                setSelected(value);
                props.onChange && props.onChange(value);
            }}
        >
            <React.Fragment key=".0">
                {(choices || []).map((choice, idx) => (
                    <RadioV2
                        labelProps={{
                            label: choice.labelProps.label
                        }}
                        value={choice.value}
                        key={idx}
                        inputRef={refs[idx]}
                    />
                ))}
            </React.Fragment>
        </RadioGroupV2>
    );
};

RadioTraditional.defaultProps = {
    choices: []
};

export default RadioTraditional;
